export class StaffService {
    constructor(staff_service) {
        this.id = staff_service.id;
        this.employee_id = staff_service.employee_id;
        this.service_id = staff_service.service_id;
        this.is_active = staff_service.is_active;
        this.service = staff_service.service;
    }
}